import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
export function Contact() {
  return <main className="flex-grow bg-brand-light" data-id="element-334">
      {/* Hero Banner */}
      <div className="relative py-20 bg-brand-dark overflow-hidden" data-id="element-335">
        <div className="absolute inset-0 opacity-10" data-id="element-336">
          <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(#A8D608 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }} data-id="element-337"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-338">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-6xl font-heading font-extrabold text-white mb-6" data-id="element-339">
            Contact <span className="text-brand-green" data-id="element-340">Us</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-341">
            We're available 24/7 for emergency response and general inquiries.
          </motion.p>
        </div>
      </div>

      <section className="py-20" data-id="element-342">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-343">
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-344">
            {/* Contact Information */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={{
            opacity: 1,
            x: 0
          }} className="lg:w-1/3 space-y-8" data-id="element-345">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-346">
                <h3 className="text-2xl font-heading font-bold text-brand-dark mb-6" data-id="element-347">
                  Get in Touch
                </h3>

                <div className="space-y-6" data-id="element-348">
                  <div className="flex items-start" data-id="element-349">
                    <div className="bg-brand-green/20 p-3 rounded-full mr-4" data-id="element-350">
                      <Phone className="w-6 h-6 text-brand-green" data-id="element-351" />
                    </div>
                    <div data-id="element-352">
                      <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-353">
                        24/7 Emergency Line
                      </p>
                      <a href="tel:08004647025" className="text-xl font-bold text-brand-dark hover:text-brand-green transition-colors" data-id="element-354">
                        0800 464 7025
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-355">
                    <div className="bg-brand-dark/5 p-3 rounded-full mr-4" data-id="element-356">
                      <Mail className="w-6 h-6 text-brand-dark" data-id="element-357" />
                    </div>
                    <div data-id="element-358">
                      <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-359">
                        Email Address
                      </p>
                      <a href="mailto:info@rapidenergy.co.uk" className="text-lg font-bold text-brand-dark hover:text-brand-green transition-colors" data-id="element-360">
                        info@rapidenergy.co.uk
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-361">
                    <div className="bg-brand-dark/5 p-3 rounded-full mr-4" data-id="element-362">
                      <Clock className="w-6 h-6 text-brand-dark" data-id="element-363" />
                    </div>
                    <div data-id="element-364">
                      <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-365">
                        Operating Hours
                      </p>
                      <p className="text-lg font-bold text-brand-dark" data-id="element-366">
                        24 Hours / 7 Days
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-brand-dark p-8 rounded-2xl shadow-xl text-white" data-id="element-367">
                <h3 className="text-xl font-heading font-bold mb-6 flex items-center" data-id="element-368">
                  <MapPin className="w-6 h-6 text-brand-green mr-3" data-id="element-369" />
                  Depot Locations
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-370">
                  We operate nationwide with strategic depot locations across
                  the UK to ensure our sub-24 hour emergency response time.
                </p>
                <ul className="space-y-3 text-sm font-medium" data-id="element-371">
                  <li className="flex items-center" data-id="element-372">
                    <span className="w-2 h-2 bg-brand-green rounded-full mr-3" data-id="element-373"></span>{' '}
                    London & South East
                  </li>
                  <li className="flex items-center" data-id="element-374">
                    <span className="w-2 h-2 bg-brand-green rounded-full mr-3" data-id="element-375"></span>{' '}
                    Midlands
                  </li>
                  <li className="flex items-center" data-id="element-376">
                    <span className="w-2 h-2 bg-brand-green rounded-full mr-3" data-id="element-377"></span>{' '}
                    North West
                  </li>
                  <li className="flex items-center" data-id="element-378">
                    <span className="w-2 h-2 bg-brand-green rounded-full mr-3" data-id="element-379"></span>{' '}
                    Scotland
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={{
            opacity: 1,
            x: 0
          }} className="lg:w-2/3" data-id="element-380">
              <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100" data-id="element-381">
                <h2 className="text-3xl font-heading font-bold text-brand-dark mb-2" data-id="element-382">
                  Send us a Message
                </h2>
                <p className="text-gray-500 mb-8" data-id="element-383">
                  Fill out the form below and one of our experts will get back
                  to you shortly.
                </p>

                <form className="space-y-6" data-id="element-384">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-385">
                    <div data-id="element-386">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-387">
                        First Name *
                      </label>
                      <input type="text" id="firstName" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-brand-light/50" required data-id="element-388" />
                    </div>
                    <div data-id="element-389">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-390">
                        Last Name *
                      </label>
                      <input type="text" id="lastName" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-brand-light/50" required data-id="element-391" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-392">
                    <div data-id="element-393">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-394">
                        Email Address *
                      </label>
                      <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-brand-light/50" required data-id="element-395" />
                    </div>
                    <div data-id="element-396">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-397">
                        Phone Number *
                      </label>
                      <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-brand-light/50" required data-id="element-398" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-399">
                    <div data-id="element-400">
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-401">
                        Company Name
                      </label>
                      <input type="text" id="company" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-brand-light/50" data-id="element-402" />
                    </div>
                    <div data-id="element-403">
                      <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-404">
                        Service Required
                      </label>
                      <select id="service" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-brand-light/50" data-id="element-405">
                        <option value="" data-id="element-406">Please select...</option>
                        <option value="boiler" data-id="element-407">Boiler Hire</option>
                        <option value="heater" data-id="element-408">Heater Hire</option>
                        <option value="chiller" data-id="element-409">Chiller Hire</option>
                        <option value="cooling" data-id="element-410">Cooling Hire</option>
                        <option value="other" data-id="element-411">Other / General Inquiry</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-412">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-413">
                      Message *
                    </label>
                    <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-brand-light/50 resize-none" required data-id="element-414"></textarea>
                  </div>

                  <button type="submit" className="inline-flex items-center justify-center px-8 py-4 bg-brand-green text-brand-dark font-bold rounded-lg hover:bg-brand-dark hover:text-white transition-colors duration-300 w-full md:w-auto" data-id="element-415">
                    SEND MESSAGE
                    <Send className="ml-2 w-5 h-5" data-id="element-416" />
                  </button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>;
}